import { render, staticRenderFns } from "./ReportsPanel.vue?vue&type=template&id=31ff566c&scoped=true"
import script from "./ReportsPanel.vue?vue&type=script&lang=js"
export * from "./ReportsPanel.vue?vue&type=script&lang=js"
import style0 from "./ReportsPanel.vue?vue&type=style&index=0&id=31ff566c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ff566c",
  null
  
)

export default component.exports